/**
 * Helpers de JWPlayer (self-hosted 8.3.32).
 */

/**
 * Trae un media del CDN de JWPlayer ya normalizado: fuentes MP4 progresivas + póster.
 * El player self-hosted trae un hls.js viejo que falla al bufferear ciertos streams HLS
 * (JW Warning 334002); por eso preferimos MP4 progresivo y armamos el playlist a mano.
 * Devuelve { sources: [], image: '' } si falla (el llamador cae al playlist del CDN).
 */
export async function fetchMedia(videoId) {
  const empty = { sources: [], image: '' };
  if (!videoId) return empty;
  try {
    const res = await fetch(`https://cdn.jwplayer.com/v2/media/${videoId}`);
    const data = await res.json();
    const item = data?.playlist?.[0] || {};
    const sources = (item.sources || [])
      .filter(s => s.type === 'video/mp4' && s.file)
      .map(s => ({ file: s.file, label: s.label, type: 'video/mp4' }));
    return { sources, image: item.image || '' };
  } catch (e) {
    console.warn('jwHelpers: no se pudo obtener el media:', e);
    return empty;
  }
}

/** Solo las fuentes MP4 (lo que necesita el VideoModal, que abre con autostart y sin póster). */
export async function fetchMp4Sources(videoId) {
  const { sources } = await fetchMedia(videoId);
  return sources;
}
